module.exports = "pegasus_template/assets/blocks/capture-5-basic.png";